module.exports = window.__IFENG_INNER_LIBS__["@ifeng/errorBoundary"];